module.exports = __webpack_public_path__ + "assets/f59237994f81f46e2968a5b9eb331c79.mp3";